import { CurrentBid } from '@strata/react-current-bid';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

export const hasAuctionEnded = (auctionEnd: dayjs.ConfigType) =>
    dayjs().diff(auctionEnd, 'seconds') >= 0;

/** Hook that returns if auction has ended */
export const useAuctionEnded = (auctionEnd: dayjs.ConfigType) => {
    const [auctionEnded, setAuctionEnded] = useState(hasAuctionEnded(auctionEnd));
    useEffect(() => {
        const interval = setInterval(() => {
            setAuctionEnded(hasAuctionEnded(auctionEnd));
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, [auctionEnd]);
    return auctionEnded;
};

/** Returns Won or Lost state if auction has ended */
export const getBidState = (
    bidState: (typeof CurrentBid.states)[keyof typeof CurrentBid.states] | undefined,
    auctionEnded: boolean,
) => {
    if (auctionEnded) {
        if (bidState === CurrentBid.states.WINNING) {
            return CurrentBid.states.WON;
        }
        if (bidState === CurrentBid.states.LOSING) {
            return CurrentBid.states.LOST;
        }
    }
    return bidState;
};
